// extracted by mini-css-extract-plugin
export default {"custom_loader_change":"changelLoader_custom_loader_change__9FZc7","s6":"changelLoader_s6__sOw4W"};